import { useEffect, useState } from 'react';
import { useQuery } from './useQuery';

const useFormStateByQuery = (initialFormState) => {
    const { filterUrl } = useQuery();
    const [formStateByQuery, setFormStateByQuery] = useState(initialFormState);

    useEffect(() => {
        const queryString = filterUrl() || '';

        const fetchData = async () => {
            const params = new URLSearchParams(queryString);
            const updatedFormState = {};

            params.forEach((value, key) => {
                updatedFormState[key] = value;
            });

            setFormStateByQuery((prevState) => ({
                ...prevState,
                ...updatedFormState,
            }));
        };

        fetchData();
    }, [filterUrl]);

    return { formStateByQuery, setFormStateByQuery };
};

export default useFormStateByQuery;
